import TableView from 'owa-mail-list-store/lib/store/schema/TableView';

/*
    We maintain a list of always cached tables here. When we add a table that should always be
    cached, we subscribe to the row notifications.
*/
let tableIdList: string[];
let onAdd: (tableView: TableView) => any;
let onRemove: (tableViewId: string) => any;

export function initialize(
    onAddCallback: (tableView: TableView) => any,
    onRemoveCallback: (tableViewId: string) => any
) {
    tableIdList = [];
    onAdd = onAddCallback;
    onRemove = onRemoveCallback;
}

export function add(tableView: TableView): number {
    const tableViewIndex = indexOf(tableView);

    if (tableViewIndex === -1) {
        tableIdList.push(tableView.id);
        onAdd(tableView);
    }

    return tableViewIndex;
}

export function remove(tableView: TableView): void {
    const tableViewIndex = indexOf(tableView);

    if (tableViewIndex !== -1) {
        tableIdList.splice(tableViewIndex, 1);
        onRemove(tableView.id);
    }
}

export function indexOf(tableView: TableView): number {
    return tableIdList.indexOf(tableView.id);
}

export function getTableIdAtIndex(index: number): string {
    return tableIdList[index];
}
